export default __webpack_public_path__ + "static/media/grocery14.fc9c95fd.jpeg";